import {Component, effect, inject, OnInit} from '@angular/core';
import {Router, RouterOutlet} from '@angular/router';
import {KEYCLOAK_EVENT_SIGNAL, KeycloakEventType} from "keycloak-angular";
import {RealmService} from "./keycloak/services/realm.service";
import {BootstrapService} from "./shared/services/bootstrap.service";
import {ThemeService} from "./shared/services/theme.service";
import {Toast} from "primeng/toast";
import {ConfirmDialog} from "primeng/confirmdialog";

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, Toast, ConfirmDialog],
    templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
    private readonly bootstrapService = inject(BootstrapService)
    private readonly router = inject(Router);

    readonly themeService = inject(ThemeService);

    constructor() {
        const keycloakSignal = inject(KEYCLOAK_EVENT_SIGNAL);
        const realmService = inject(RealmService)

        this.captureRealm(realmService);

        effect(async () => {
            const keycloakEvent = keycloakSignal();

            if (keycloakEvent.type === KeycloakEventType.AuthLogout) {
                await realmService.clearStorage()
            }
        });
    }

    ngOnInit(): void {
        this.bootstrapService.initApplicationData()
            .catch(error => console.error('Failed to initialize application data:', error));
    }

    private captureRealm(realmService: RealmService): void {
        const urlParams = new URLSearchParams(globalThis.location.search);
        const realm = urlParams.get('realm');
        const email = urlParams.get('email');
        let changed = false;

        if (realm) {
            realmService.realm = realm;
            changed = true;
        }
        if (email) {
            realmService.mail = email;
            changed = true;
        }
        if (changed) {
            this.router.navigate([], {
                queryParams: {realm: null, email: null},
                queryParamsHandling: 'merge',
                replaceUrl: true,
            });
        }
    }
}
